import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm, submit, Form } from "redux-form";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Button,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  withMobileDialog,
  withStyles,
  Checkbox,
  Grid,
  FormHelperText
} from "@material-ui/core";
import * as AccountActions from "../../../../store/AccountHierarchy";
import * as SnackbarActions from "../../../../store/SnackbarStore";
import {
  CreateCustomAccount,
  UpdateCustomAccount
} from "../../../../services/accountService";
import styles from "../../../../wrappers/admin/Admin.Styles";
import PropTypes from "prop-types";

const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;
const mustStartWith = prefix => value =>
  value && !value.startsWith(prefix) ? `Must start with ${prefix}` : undefined;

const maxLength256 = maxLength(256);
const mustStartWithM = mustStartWith("M");

const validate = values => {
  const errors = {};
  const requiredFields = ["number", "name", "accountTypeId"];
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = "Required";
    }
  });

  const maxLengthFields = ["name"];
  maxLengthFields.forEach(field => {
    if (maxLength256(values[field])) {
      errors[field] = maxLength256(values[field]);
    }
  });

  if (mustStartWithM(values["number"])) {
    errors["number"] = mustStartWithM(values["number"]);
  }

  return errors;
};

const renderTextField = ({
  input,
  label,
  name,
  meta: { touched, error },
  ...custom
}) => {
  return (
    <TextField
      name={name}
      label={label}
      helperText={touched && error}
      error={touched && error !== undefined}
      {...input}
      {...custom}
      margin="normal"
    />
  );
};

const selectStyle = theme => ({
  root: {
    position: "unset"
  },
  selectMed: {
    marginTop: 24,
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    width: 300
  },
  helperText: {
    position: "relative",
    top: 20
  }
});

const renderSelectField = withStyles(selectStyle)(
  ({
    input,
    name,
    label,
    meta: { touched, error },
    menuItems,
    classes,
    ...custom
  }) => (
    <FormControl
      className={classes.selectMed}
      error={touched && error !== undefined}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        name={name}
        {...input}
        {...custom}
        style={{ position: "unset" }}
        classes={{
          root: classes.root,
          select: classes.root,
          selectMenu: classes.root
        }}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {menuItems.map(child => (
          <MenuItem key={child.id} value={child.id}>
            {child.name}
          </MenuItem>
        ))}
      </Select>
      {touched && error !== undefined ? (
        <FormHelperText error className={classes.helperText}>
          {error}
        </FormHelperText>
      ) : (
        undefined
      )}
    </FormControl>
  )
);

const renderCheckbox = ({ input, label, name, ...custom }) => {
  //debugger;
  return (
    <FormControlLabel
      control={
        <Checkbox
          name={name}
          label={label}
          {...input}
          checked={input.value}
          value={input.value ? "yes" : "no"}
          {...custom}
        />
      }
      label={label}
    />
  );
};

export const CustomAccountFormMode = Object.freeze({
  CREATE: Symbol("create"),
  EDIT: Symbol("edit")
});

class CustomAccountForm extends Component {
  handleSubmit = async customAccount => {
    const { sendError } = this.props;
    console.log(customAccount);
    try {
      const mode =
        customAccount.id > 0
          ? CustomAccountFormMode.EDIT
          : CustomAccountFormMode.CREATE;
      const result =
        customAccount.id > 0
          ? await UpdateCustomAccount(customAccount)
          : await CreateCustomAccount(customAccount);

      if (result) {
        this.props.submitted(result, mode);
      }
    } catch (error) {
      console.log(error);
      sendError(error);
    }
  };

  render() {
    const { classes, accountTypes, handleSubmit } = this.props;

    return (
      <div className={classes.root}>
        <Form onSubmit={handleSubmit(this.handleSubmit)}>
          <Grid container spacing={24} />
          <Grid item xs={12}>
            <Field
              name="number"
              component={renderTextField}
              label="Number"
              className={classes.textFieldMed}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              name="name"
              component={renderTextField}
              label="Name"
              className={classes.textFieldMed}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              name="accountTypeId"
              component={renderSelectField}
              label="Account Type"
              className={classes.textFieldMed}
              menuItems={accountTypes}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              name="isActive"
              component={renderCheckbox}
              label="Active"
              className={classes.checkbox}
            />
          </Grid>
        </Form>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    initialValues: state.customAccounts.data,
    accountTypes: state.customAccounts.accountTypes || []
  };
}

CustomAccountForm = connect(
  mapStateToProps,
  dispatch =>
    bindActionCreators(
      Object.assign(
        {},
        SnackbarActions.actionCreators,
        AccountActions.actionCreators
      ),
      dispatch
    )
)(
  reduxForm({
    form: "CustomAccountForm",
    validate
  })(withStyles(styles)(CustomAccountForm))
);

class CustomAccountModalForm extends Component {
  state = {
    customAccount: {
      id: 0,
      name: "",
      alias: ""
    }
  };

  getTitle = () => {
    return this.state.customAccount.id
      ? "Edit Custom Account"
      : "Add Custom Account";
  };

  componentDidMount() {
    const { initialValues } = this.props;
    this.setState({ customAccount: { ...initialValues } });
  }

  render() {
    const { open, fullscreen, handleClose, dispatch } = this.props;

    return (
      <Dialog
        fullscreen={fullscreen}
        open={open}
        onClose={this.handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {this.getTitle()}
        </DialogTitle>
        <DialogContent>
          <CustomAccountForm submitted={handleClose} />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              dispatch(submit("CustomAccountForm"));
            }}
            color="primary"
          >
            Ok
          </Button>
          <Button onClick={handleClose} color="primary" autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

CustomAccountModalForm.propTypes = {
  open: PropTypes.bool.isRequired
};

export default connect(state => ({
  initialValues: state.customAccounts.data
}))(withStyles(styles)(withMobileDialog()(CustomAccountModalForm)));
